import { Component, OnInit, ElementRef, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { StatefulCSS } from 'src/app/model/stateful_css';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { ControlledVocabApiService, TypeAheadExtantParams, TypeAheadManagedParams } from 'src/app/model/api-services/controlled-vocab-api.service';
import { SLLayer } from 'src/app/model/sl-layer';
import { KVPairList, Value, ValList, KVPair } from 'src/app/types/kv';
import { InputComponent } from '../input/input.component';
import { SL_ID_PREFIX, SlIdContext } from 'src/app/model/directives/sl-id-context';



@Component({
	selector: 'app-text-input',
	templateUrl: './text-input.component.html',
	styleUrls: ['./text-input.component.scss'],
	changeDetection:ChangeDetectionStrategy.OnPush,
  providers: [
      SlIdContext,
      {
        provide: SL_ID_PREFIX,
        useValue: 'attr-text-input'
      }
    ],
})
export class TextInputComponent
	extends InputComponent
	implements OnInit, OnDestroy {


	public searchTerm = '';
	public useInput = false;
	public useTypeAhead = false;
	public useTypeAheadLimited = false;
	public useTextArea = false;
	public useRichText = false;
	public useSelect = false;
	public minChars = 0;
	public maxChars = Number.MAX_SAFE_INTEGER;
	public typeAheadValue = '';
	public editorConfig = {
		toolbarGroups: [
			{ name: 'styles', groups: ['styles'] },
			{ name: 'document', groups: ['mode', 'document', 'doctools'] },
			{ name: 'colors', groups: ['colors'] },
			{ name: 'clipboard', groups: ['clipboard', 'undo'] },
			{ name: 'insert', groups: ['insert'] },
			{ name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
			{ name: 'forms', groups: ['forms'] },
			{ name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
			{ name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
			{ name: 'links', groups: ['links'] },
			{ name: 'tools', groups: ['tools'] },
			{ name: 'others', groups: ['others'] },
			{ name: 'about', groups: ['about'] }
		],
		removeButtons: 'Save,NewPage,Preview,Print,Templates,HiddenField,ImageButton,Button,Select,Textarea,TextField,Radio,Checkbox,Form,Image,Flash,Smiley,PageBreak,Maximize,About,ShowBlocks',
		toolbarCanCollapse: true,
		toolbarStartupExpanded: false
	}




	public reqStates!: StatefulCSS;
	public modStates!: StatefulCSS;
	public vocab: KVPairList | ValList = [];
	public vocabType: 'none' | 'ValList' | 'KVPairList' = 'none';
	public params: TypeAheadExtantParams | TypeAheadManagedParams | any = {};
	public typeAheadContext!: 'extant' | 'managed';
	search = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(300),
			distinctUntilChanged(),
			switchMap((searchText) => this.service.TypeAhead(this.params, searchText, this.typeAheadContext))
		);
	formatter = (value: any) => {
		if (value === '') {
			return '';
		}
		if (!!value.k) {
			return value.k;
		}
		return value.v;

	}

	// tslint:disable-next-line: member-ordering

	constructor(private domNode: ElementRef, private service: ControlledVocabApiService,protected cdr:ChangeDetectorRef) {
		super(cdr);
		this._domNode = this.domNode;

	}

	/* ngOnInit(): void {
		super.ngOnInit();
	}*/
	Validate(): boolean {
		return false;
	}
	SetAttribute(layer: SLLayer, attribute: AttributeInfo) {
		super.SetAttribute(layer, attribute);
		if (!!attribute.vocab) {
			if (attribute.vocab.useTypeAhead === true) {
				this.useTypeAhead = true;

				// Setup TypeAheadSearch
			}
			if ((attribute.vocab.limitToExisting === true) && (this.useTypeAhead === true)) {
				this.useTypeAheadLimited = true;
				this.typeAheadContext = 'extant';
				this.params.layerId = layer.id;
				this.params.attribute = this.attribute.name;
				if (!!this.params.id) {
					delete this.params.id;
				}
				this.params.limit = 10;
			} else if ((!!attribute.vocab.managedVocab) && (this.useTypeAhead === false)) {

				this.service.GetVocabById(attribute.vocab.managedVocab.id as number, (response) => {
					if (!!response.vocab_v5) {
						if (!!response.vocab_v5.vocab) {
							const val = this.currentValue;
							this.vocab = response.vocab_v5.vocab;
							this.vocabType = response.vocab_v5.type;
							this.useSelect = true;
							this.cdr.detectChanges();
							window.requestAnimationFrame(() => {
								this.currentValue = val;
							});


						}
					}
				}, (problem) => { problem = problem; });
			} else if ((!!attribute.vocab.managedVocab) && (this.useTypeAhead === true)) {
				if (attribute.vocab.managedVocab.type === 'none') {

				} else if (!!attribute.vocab.managedVocab.id) {
					this.typeAheadContext = 'managed';
					(this.params as TypeAheadManagedParams).id = attribute.vocab.managedVocab.id;
					if (!!this.params.attribute) {
						delete this.params.attribute;
					}
					if (!!(this.params as TypeAheadExtantParams).layerId) {
						delete (this.params as any).layerId
					}
					this.params.limit = 10;


				}
			}

		} else {
			let isBasic = true;
			if (!!attribute.casting) {
				if (!!attribute.casting.entry?.text?.input) {
					isBasic = false;
					switch (attribute.casting.entry.text.input) {
						case 'single':
							this.useInput = true;
							break;
						case 'textarea':
							this.useTextArea = true;
							break;
						case 'rich':
							this.useRichText = true;
							break;
					}
					this.minChars = attribute.casting.entry.text.minChars;
					this.maxChars = attribute.casting.entry.text.maxChars;
				}
			}
			if (isBasic === true) {
				this.useInput = true;
			}
		}
	}

	Reset() {
		super.Reset();
		this.useInput = false;
		this.useTypeAhead = false;
		this.useTypeAheadLimited = false;
		this.useTextArea = false;
		this.useSelect = false;
		this.minChars = 0;
		this.maxChars = Number.MAX_SAFE_INTEGER;
	}
	TypeAheadUnselected(val: string) {
		this.currentValue = val;
	}
	TypeAheadUpdate(val: Value | KVPair) {

		this.currentValue = val.v;


	}
	Update() {

	}


}
